import { render, staticRenderFns } from "./TrackingConsentPopup.vue?vue&type=template&id=20d68312&scoped=true&"
import script from "./TrackingConsentPopup.vue?vue&type=script&lang=js&"
export * from "./TrackingConsentPopup.vue?vue&type=script&lang=js&"
import style0 from "./TrackingConsentPopup.vue?vue&type=style&index=0&id=20d68312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d68312",
  null
  
)

export default component.exports